import React from 'react';
import Select from 'react-select';

export default function FeatureFilter({categories, setFilter}) {
    const formattedCategories = categories.map(category => ({ value: category, label: category === "undefined" ? "Not categorized" : category }))
    const theme = theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#9575CD',
          primary25: '#faf5ff',
          primary50: '#d6bcfa',
          neutral20: '#e2e8f0',
          neutral30: '#cbd5e0'
        },
      })
    return (
        <div className="w-64 mr-5 px-3">
            <Select 
                id="featureFilter" 
                onChange={(v) => setFilter("Category",v ? v.value : undefined)} 
                options={formattedCategories}
                isClearable={true}
                placeholder="Category..."
                theme={theme}
                menuPlacement="top"
                />
            <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="featureFilter">
                Filter by Category
            </label>
        </div>
    )
}